var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo } from 'react';
import DialogStylesContext from './DialogStylingContext';
import { DialogContainer, DialogSurface, DialogTitle, Modal, StyledBackdrop, Transition, useDialogStylesWarning, useVariant, } from './DialogInternals';
var defaultPadding = {
    paddingTop: '20px',
    paddingRight: '24px',
    paddingBottom: '24px',
    paddingLeft: '24px',
};
var Dialog = function (_a) {
    var children = _a.children, _b = _a.padding, _c = _b === void 0 ? defaultPadding : _b, _d = _c.paddingTop, paddingTop = _d === void 0 ? defaultPadding.paddingTop : _d, _e = _c.paddingRight, paddingRight = _e === void 0 ? defaultPadding.paddingRight : _e, _f = _c.paddingBottom, paddingBottom = _f === void 0 ? defaultPadding.paddingBottom : _f, _g = _c.paddingLeft, paddingLeft = _g === void 0 ? defaultPadding.paddingLeft : _g, title = _a.title, _h = _a.hideCloseButton, hideCloseButton = _h === void 0 ? false : _h, _j = _a.width, width = _j === void 0 ? 'md' : _j, _k = _a.desktopVariant, desktopVariant = _k === void 0 ? 'default' : _k, _l = _a.mobileVariant, mobileVariant = _l === void 0 ? 'default' : _l, _m = _a.scroll, scroll = _m === void 0 ? 'content' : _m, sx = _a.sx, titleSx = _a.titleSx, surfaceSx = _a.surfaceSx, _o = _a.titleComponent, titleComponent = _o === void 0 ? 'header' : _o, props = __rest(_a, ["children", "padding", "title", "hideCloseButton", "width", "desktopVariant", "mobileVariant", "scroll", "sx", "titleSx", "surfaceSx", "titleComponent"]);
    var variant = useVariant(desktopVariant, mobileVariant);
    var padding = useMemo(function () { return ({
        paddingTop: paddingTop,
        paddingRight: paddingRight,
        paddingBottom: paddingBottom,
        paddingLeft: paddingLeft,
    }); }, [paddingTop, paddingRight, paddingBottom, paddingLeft]);
    var providerValue = useMemo(function () { return ({ padding: padding, scroll: scroll }); }, [padding, scroll]);
    useDialogStylesWarning({ surfaceSx: surfaceSx });
    return (React.createElement(DialogStylesContext.Provider, { value: providerValue },
        React.createElement(Modal, __assign({}, props, { open: props.open, slots: {
                backdrop: StyledBackdrop,
            }, closeAfterTransition: true }),
            React.createElement(Transition, { variant: variant, in: props.open },
                React.createElement(DialogContainer, __assign({}, { variant: variant, scroll: scroll, sx: sx }, { "data-testid": "DialogContainer" }),
                    React.createElement(DialogSurface, __assign({}, { variant: variant, width: width, padding: padding, scroll: scroll }, { sx: surfaceSx, "data-testid": "DialogSurface" }),
                        React.createElement(DialogTitle, __assign({}, {
                            hideCloseButton: hideCloseButton,
                            padding: padding,
                            titleSx: titleSx,
                            scroll: scroll,
                            titleComponent: titleComponent,
                        }, { onClose: props.onClose, title: title })),
                        children))))));
};
export default Dialog;
//# sourceMappingURL=Dialog.js.map